<template>
  <v-list class="pa-0 py-2" style="height: 52px">
    <v-list-item class="header">
      <v-list-item-avatar class="mr-0">
        <component :is="icon" class="logoFormSVG" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="object-title" :class="{ 'mb-1': !subTitle }">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="subTitle" class="object-subtitle">
          {{ subTitle }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn icon x-small @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import PoleFillSVG from "@/assets/network_module/object_forms/pole.svg";
import CabinetFillSVG from "@/assets/network_module/object_forms/cabinet.svg";
import ChambreFillSVG from "@/assets/network_module/object_forms/manhole.svg";
import CableFillSVG from "@/assets/tools_svgs/cableFill.svg";
import ClosureFillSVG from "@/assets/tools_svgs/closureFill.svg";
import TobyBoxFillSVG from "@/assets/network_module/object_forms/toby_box.svg";
import COFillSVG from "@/assets/network_module/object_forms/co.svg";
import PNFillSVG from "@/assets/network_module/object_forms/pn.svg";
import PNAreaFillSVG from "@/assets/tools_svgs/pnAreaFill.svg";
import COAreaFillSVG from "@/assets/tools_svgs/coFill.svg";
import ClosureAreaFillSVG from "@/assets/tools_svgs/closureAreaFill.svg";
import InfraFillSVG from "@/assets/tools_svgs/infraFill.svg";
import BuildingFillSVG from "@/assets/network_module/object_forms/building.svg";
import TechnicalLocalFillSVG from "@/assets/tools_svgs/oltFill.svg";

export default {
  name: "ObjectFormHeader",

  components: {
    PoleFillSVG,
    CabinetFillSVG,
    ChambreFillSVG,
    CableFillSVG,
    ClosureFillSVG,
    TobyBoxFillSVG,
    COFillSVG,
    PNFillSVG,
    PNAreaFillSVG,
    COAreaFillSVG,
    ClosureAreaFillSVG,
    InfraFillSVG,
    BuildingFillSVG,
    TechnicalLocalFillSVG
  },

  props: {
    /**
     * Title of the form.
     */
    title: {
      type: String,
      required: true
    },

    /**
     * SubTitle of the form.
     */
    subTitle: String,

    /**
     * Layer of selected object
     */
    layer: {
      type: String,
      required: true
    }
  },

  computed: {
    /**
     * Returns the icon corresponding to the layer of the selected object
     * @returns {string}
     */
    icon() {
      let objectComponent;
      if (this.layer) {
        switch (this.layer) {
          case "fc_pole":
            objectComponent = "Pole";
            break;
          case "fc_manhole":
            objectComponent = "Chambre";
            break;
          case "fc_cabinet":
            objectComponent = "Cabinet";
            break;
          case "fc_toby_box":
            objectComponent = "TobyBox";
            break;
          case "fc_building":
            objectComponent = "Building";
            break;
          case "fc_pathway":
            objectComponent = "Infra";
            break;
          case "fc_closure":
            objectComponent = "Closure";
            break;
          case "fc_cable":
            objectComponent = "Cable";
            break;
          case "fc_fiber_distribution_point":
            objectComponent = "PN";
            break;
          case "fc_optical_line_termination":
            objectComponent = "CO";
            break;
          case "fc_fdp_zone":
            objectComponent = "PNArea";
            break;
          case "fc_olt_zone":
            objectComponent = "COArea";
            break;
          case "fc_closure_zone":
            objectComponent = "ClosureArea";
            break;
          case "fc_technical_local_olt":
          case "fc_technical_local_fdp":
            objectComponent = "TechnicalLocal";
          case "fc_microduct_bundle":
            objectComponent = "Bundle"
          case "fc_virtual":
            objectComponent = "Virtual"
        }
        return objectComponent + "FillSVG";
      } else return "";
    }
  }
};
</script>

<style scoped>
.logoFormSVG {
  width: 16px;
  height: 16px;
  position: relative;
  z-index: 1;
}

.object-title {
  text-align: left;
  font: normal normal 600 12px/14px Segoe UI;
  color: #32383d;
  line-height: inherit;
  height: 14px;
}

.object-subtitle {
  text-align: left;
  font: normal normal normal 10px/14px Segoe UI;
  color: #4fa2b7 !important;
  line-height: inherit;
  height: 14px;
}

.header {
  height: 38px !important;
  min-height: 38px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/Forms/_Molecules/ObjectFormHeader.vue